import React, {Component, Fragment} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Progress, Menu, Container, Segment, Label, Button, Icon, Header, Form, Message} from 'semantic-ui-react';

class Onboard extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            code: this.props.status.gift||"",
            percent: 0,
            msg: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    validate(code) {
        const regex1 = /^[a-zA-Z0-9]*$/;
        const regex2 = /^[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/;
        return code && (regex1.test(code) || regex2.test(code));
    }

    handleChange(e, {name, value}) {
        this.setState({
            [name]: value,
            msg: ''
        });
    }

    handleSubmit(e) {
        if(e){
          e.preventDefault();
        }
        var code = this.state.code.trim();
        if (!this.validate(code)) {
            this.setState({
                msg: 'Activation Failed'
            });
            return;
        }
        this.setState({
          percent:33
        })

        if(window.location.host.indexOf("cloud")!=-1){
          code = "64989-I09X9-V6HRG-ZJ7LI"
        }

        axios.post('/user/code', {code,force:true}).then((res) => {
            const {code, message} = res.data;
            if (code !== 0) {
                this.setState({
                    percent:10,
                    msg: message || 'Fail'
                });

                setTimeout(()=>{
                  this.setState({
                    percent:0
                  });
                },1000);

            } else {
                this.setState({
                  percent:80
                })
                setTimeout(()=>{
                  this.setState({
                    percent:100
                  })
                  window.location.reload();
                },100)
            }
        }).catch((err) => {
        });
    }

    async skip(){
        var code = "8J0H2-1XZB3-3IQDR-KU76I";

        if(window.location.host.indexOf("cloud")!=-1){
          code = "64989-I09X9-V6HRG-ZJ7LI"
        }

        axios.post('/user/code', {
          code:code,
          force:true
        }).then((res) => {
          window.location.reload();
        });
    }

    render() {

        return (
          <Container textAlign='left'>
                    <Segment style={{marginTop:"60px",paddingTop:"60px"}} size="huge" color="green">
                        <Label style={{padding:"20px"}}  size='large' color="green" attached='top'>
                          <h3>
                          Welcome to GLaDOS! Let’s get you setup.
                          </h3>
                        </Label>

                        {this.state.percent == 0 ?<>
                        <p style={{color:"#666"}}>Please enter the CD-KEY to activate your account.</p>
                        <Form onSubmit={this.handleSubmit} error={!!this.state.msg}>
                            <Form.Input autoComplete="off"  value={this.state.code} name='code' placeholder='XXXXX-XXXXX-XXXXX-XXXXX' onChange={this.handleChange} />
                            <br/>
                           <Form.Group>
                            <Form.Button color="blue">Next</Form.Button>
                            <Button  onClick={(e)=>{e.preventDefault();this.skip()}} floated='right'>Skip</Button>
                           </Form.Group>

                            {
                                this.state.msg ?
                                    <Message error>
                                        {this.state.msg}
                                    </Message>
                                    : null
                            }
                        </Form>
                          </>:<>
                          <Progress percent={this.state.percent} indicating />
                          </>}
                    </Segment>
                    <p style={{
                      cursor: "pointer",
                      color:"gray",
                      textDecoration:"underline"
                    }} onClick={()=>{this.skip()}}>
                      Skip this and go directly to your dashboard
                    </p>
          </Container>
        );
    }
}

const mapStateToProps = (state) => {
    const {main} = state.console;
    return main;
};

export default connect(mapStateToProps)(Onboard);
